import { Typography as e } from "../../Typography/Typography.mjs";
import { useMobileSwipe as t } from "../../hooks/useMobileSwipe.mjs";
import n from "react";
import { createGlobalStyle as r, keyframes as i, styled as a } from "styled-components";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as c from "@radix-ui/react-dropdown-menu";
//#region src/components/DropdownMenu/DropdownMenuContent.tsx
var l = r`
    @media (max-width: 768px) {
        [data-radix-popper-content-wrapper]:has(.maat-mobile-fullscreen-dropdown) {
            transform: none !important;
            left: 0 !important;
            top: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            max-width: none !important;
        }
    }
`, u = i`
    from { opacity: 0; transform: scale(0.97); }
    to   { opacity: 1; transform: scale(1); }
`, d = i`
    from { transform: translateX(0); }
    to { transform: translateX(100%); }
`, f = a(c.Content)`
    min-width: 200px;
    background-color: ${({ theme: e }) => e.colors.card};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    box-shadow: ${({ theme: e }) => e.shadows.lg};
    padding: ${({ theme: e }) => e.spacing(.5)};
    z-index: 2000;
    animation: ${u} ${({ theme: e }) => e.transitions.fast} ease;
    outline: none;

    @media (max-width: 768px) {
        position: fixed !important;
        inset: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        max-width: none !important;
        max-height: none !important;
        border-radius: 0 !important;
        border: none !important;
        transform: none !important;
        margin: 0 !important;
        padding: env(safe-area-inset-top, 16px) 16px env(safe-area-inset-bottom, 16px) 16px !important;
        box-sizing: border-box !important;
        display: flex;
        flex-direction: column;

        &[data-state='closed'] {
            animation: ${d} 200ms ease-in;
        }
    }
`, p = a(c.SubContent)`
    min-width: 180px;
    background-color: ${({ theme: e }) => e.colors.card};
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    box-shadow: ${({ theme: e }) => e.shadows.lg};
    padding: ${({ theme: e }) => e.spacing(.5)};
    z-index: 2001;
    animation: ${u} ${({ theme: e }) => e.transitions.fast} ease;
    outline: none;

    @media (max-width: 768px) {
        position: fixed !important;
        inset: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        max-width: none !important;
        max-height: none !important;
        border-radius: 0 !important;
        border: none !important;
        transform: none !important;
        margin: 0 !important;
        padding: env(safe-area-inset-top, 16px) 16px env(safe-area-inset-bottom, 16px) 16px !important;
        box-sizing: border-box !important;
        display: flex;
        flex-direction: column;
    }
`, m = a.div`
    display: none;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme: e }) => e.spacing(3, 1.5)};
    flex-shrink: 0;

    @media (max-width: 768px) {
        display: flex;
    }
`, h = a.button`
    display: none;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: none;
    background: transparent;
    color: ${({ theme: e }) => e.colors.foreground};
    cursor: pointer;
    transition: background-color ${({ theme: e }) => e.transitions.fast};

    &:hover,
    &:active {
        background-color: ${({ theme: e }) => e.colors.muted};
    }

    @media (max-width: 768px) {
        display: flex;
    }
`, g = () => /* @__PURE__ */ s("svg", {
	width: "20",
	height: "20",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "2",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	children: [/* @__PURE__ */ o("line", {
		x1: "18",
		y1: "6",
		x2: "6",
		y2: "18"
	}), /* @__PURE__ */ o("line", {
		x1: "6",
		y1: "6",
		x2: "18",
		y2: "18"
	})]
}), _ = n.forwardRef((e, r) => {
	let i = n.useRef(null), a = r || i, { onTouchStart: u, onTouchEnd: d } = t({ onSwipe: (e) => {
		e === "right" && document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" }));
	} });
	return /* @__PURE__ */ s(n.Fragment, { children: [/* @__PURE__ */ o(l, {}), /* @__PURE__ */ o(c.Portal, { children: /* @__PURE__ */ s(f, {
		ref: a,
		sideOffset: 6,
		onTouchStart: u,
		onTouchEnd: d,
		...e,
		className: ["maat-mobile-fullscreen-dropdown", e.className].filter(Boolean).join(" "),
		children: [/* @__PURE__ */ o(m, { children: /* @__PURE__ */ o(h, {
			onClick: () => document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" })),
			children: /* @__PURE__ */ o(g, {})
		}) }), e.children]
	}) })] });
});
_.displayName = "DropdownMenuContent";
var v = n.forwardRef((r, i) => {
	let a = n.useRef(null), u = i || a, { onTouchStart: d, onTouchEnd: f } = t({ onSwipe: (e) => {
		e === "right" && document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" }));
	} });
	return /* @__PURE__ */ s(n.Fragment, { children: [/* @__PURE__ */ o(l, {}), /* @__PURE__ */ o(c.Portal, { children: /* @__PURE__ */ s(p, {
		ref: u,
		sideOffset: 4,
		onTouchStart: d,
		onTouchEnd: f,
		...r,
		className: ["maat-mobile-fullscreen-dropdown", r.className].filter(Boolean).join(" "),
		children: [/* @__PURE__ */ s(m, { children: [/* @__PURE__ */ o(e, {
			variant: "h4",
			weight: "semibold",
			children: "Options"
		}), /* @__PURE__ */ o(h, {
			onClick: () => document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape" })),
			children: /* @__PURE__ */ o(g, {})
		})] }), r.children]
	}) })] });
});
v.displayName = "DropdownMenuSubContent";
//#endregion
export { _ as DropdownMenuContent, v as DropdownMenuSubContent };
